import { createApp } from 'vue';
import Mp4ToMp3Converter from '@/Components/Mp4ToMp3Converter.vue';
import '@styles/app.css';

createApp(Mp4ToMp3Converter).mount('#mp4-to-mp3-converter');
